/**
 * 全局样式常量
 * 用于 Web 和 Electron 两端统一样式
 */

// 主题色
export const COLOR_PRIMARY = '#FA7443';
export const COLOR_PRIMARY_HOVER = '#e5683c';

// Modal 圆角
export const MODAL_RADIUS_S = 20;
export const MODAL_RADIUS_M = 24;

// 默认使用中等圆角
export const DEFAULT_MODAL_RADIUS = MODAL_RADIUS_M;
